export function ImportedToolFrame({ title, description, src, openLabel = "Open full view" }) {
  const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  return (
    <div className="card-dark p-5" data-testid={`ai-ops-frame-${slug}`}>
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div>
          <div className="overline text-[var(--red)] mb-2">Imported Internal Tool</div>
          <h3 className="font-display text-xl font-semibold tracking-tight mb-1">{title}</h3>
          <p className="text-sm text-[var(--text-2)]">{description}</p>
        </div>
        <a href={src} target="_blank" rel="noreferrer" className="btn-ghost self-start" data-testid={`ai-ops-open-${slug}`}>
          {openLabel}
        </a>
      </div>

      <div className="border border-[var(--border)] overflow-hidden rounded-md bg-white" data-testid={`ai-ops-iframe-wrap-${slug}`}>
        <iframe
          src={src}
          title={title}
          className="w-full h-[720px] bg-white"
          data-testid={`ai-ops-iframe-${slug}`}
        />
      </div>
    </div>
  );
}